const MAX_NOTE_PREVIEWS = 4

export function getGalleryNotePreviewImageURLs(serverUrl: string, noteId: string, numPages: number) {
  const urls: string[] = []
  for (let i = 0; i < Math.min(numPages, MAX_NOTE_PREVIEWS); i++) {
    urls.push(getGalleryNotePreviewImageURL(serverUrl, noteId, i))
  }
  return urls
}

export function getGalleryNotePreviewImageURL(serverUrl: string, noteId: string, pageNumber?: number) {
  return `${serverUrl}/g/preview/${noteId}${typeof pageNumber === 'undefined' ? '' : '/' + pageNumber}.jpg`
}

export interface NoteDownloadURLArgs {
  fileType: 'pdf' | 'note' | 'ntb'
  noteType: 'gallery' | 'classic'
  noteId: string
  noteName: string
}

export function getNoteDownloadURL(
  serverURL: string,
  {fileType, noteId, noteName, noteType = 'gallery'}: NoteDownloadURLArgs
) {
  const prefix = noteType === 'gallery' ? 'g' : 'n'

  switch (fileType) {
    case 'pdf':
      return `${serverURL}/${prefix}/download/pdf/${noteId}/${noteName}.pdf`
    case 'ntb':
      return `${serverURL}/${prefix}/download/ntb/${noteId}/${noteName}.ntb`
    case 'note':
    default:
      return `${serverURL}/${prefix}/download/zip/${noteId}/${noteName}.note`
  }
}
